export class ImageSoucre
{
        public static instance = new ImageSoucre();

    Deckel = require("../img/PremioGas2_Garhaube.png");
    Unterschrannk= require("../img/PremioGas2_Unterschrank.png");
    Gashalter= require("../img/PremioGas2_Gashalter.png");
    Drehspiess = require("../img/PremioGas2_Drehspiess.png");
    Tischbrenner = require("../img/PremioGas2_Tischbrenner.png");
    Seitenablage = require("../img/PremioGas2_Seitenablage.png");
    Deckelnone = require("../img/PremioGas2_Garhaube_disabled.png");
    Unterschrannknone = require("../img/PremioGas2_Unterschrank_disabled.png");
    Gashalternone = require("../img/PremioGas2_Gashalter_disabled.png");
    Drehspiessnone = require("../img/PremioGas2_Drehspiess_disabled.png");
    Tischbrennernone = require("../img/PremioGas2_Tischbrenner_disabled.png");
    Seitenablagenone = require("../img/PremioGas2_Seitenablage_disabled.png");
    XLDeckel = require("../img/PremioGas2_XL_Garhaube.png");
    XLUnterschrannk = require("../img/PremioGas2_XL_Unterschrank.png");
    XLGashalter = require("../img/PremioGas2_XL_Gashalter.png");
    XLDrehspiess = require("../img/PremioGas2_XL_Drehspiess.png");
    XLTischbrenner = require("../img/PremioGas2_XL_Tischbrenner.png");
    XLSeitenablage = require("../img/PremioGas2_XL_Seitenablage.png");
    XLDeckelnone = require("../img/PremioGas2_XL_Garhaube_disabled.png");
    XLUnterschrannknone = require("../img/PremioGas2_XL_Unterschrank_disabled.png");
    XLGashalternone = require("../img/PremioGas2_XL_Gashalter_disabled.png");
    XLDrehspiessnone = require("../img/PremioGas2_XL_Drehspiess_disabled.png");
    XLTischbrennernone = require("../img/PremioGas2_XL_Tischbrenner_disabled.png");
    XLSeitenablagenone = require("../img/PremioGas2_XL_Seitenablage_disabled.png");
}